//import global API
import Api from '../../api/Api'

// Stores a password-style session (login response: data.user, data.token, data.menu).
// Shared by the password login and the email-code login so both leave the same state.
function storeSession(commit, data) {
  const token = data.data.token
  const user = data.data.user
  const menu = data.data.menu
  //set localStorage untuk menyimpan token dan data user
  localStorage.setItem('token', token)
  localStorage.setItem('user', JSON.stringify(user))
  localStorage.setItem('menu', JSON.stringify(menu))
  localStorage.setItem('with_google', 0)
  //set default header axios dengan token
  Api.defaults.headers.common['Authorization'] = `Bearer ${token}`

  //commit auth success ke mutation
  commit('AUTH_SUCCESS', token, user)
  commit('AUTH_USER', user)
  commit('AUTH_PROFILE', JSON.stringify(user))
  commit('AUTH_MENU', menu)
}

const auth = {
  //set namespace true
  namespaced: true,

  //state
  state: {
    //state untuk "token", pakai localStorage, untuk menyimpan informasi tentang token
    token: localStorage.getItem('token') || '',
    profile: {},
    user: {},
    // user: JSON.parse(localStorage.getItem('user')) || {},
    menu: [],
    // menu: JSON.parse(localStorage.getItem('menu')) || []
  },

  //mutations
  mutations: {
    //update state "token" dan state "user" dari hasil response
    AUTH_SUCCESS(state, token) {
      state.token = token
    },
    AUTH_USER(state, user) {
      state.user = user
    },
    AUTH_PROFILE(state, profile) {
      state.profile = profile
    },
    AUTH_MENU(state, menu) {
      state.menu = menu
    },

    //fungsi logout
    AUTH_LOGOUT(state) {
      state.token = ''
      state.user = {}
    },
  },

  //actions
  actions: {
    //action register
    register({ commit }, user) {
      //define callback promise
      return new Promise((resolve, reject) => {
        //send data ke server
        Api.post('/register', user)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response.data)
          })
      })
    },
    // Email-OTP registration: prove the address before the account exists.
    // request -> emails a 6-digit code; verify -> returns a ticket; complete -> creates
    // the (already verified) user. All reject with error.response.data, like register().
    register_request_otp({ commit }, payload) {
      return new Promise((resolve, reject) => {
        Api.post('/register/request-otp', payload)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response ? error.response.data : error)
          })
      })
    },
    register_verify_otp({ commit }, payload) {
      return new Promise((resolve, reject) => {
        Api.post('/register/verify-otp', payload)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response ? error.response.data : error)
          })
      })
    },
    register_complete({ commit }, payload) {
      return new Promise((resolve, reject) => {
        Api.post('/register/complete', payload)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response ? error.response.data : error)
          })
      })
    },
    lupa_password({ commit }, user) {
      return new Promise((resolve, reject) => {
        Api.post('/lupa_password', user)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    reset_password({ commit }, user) {
      return new Promise((resolve, reject) => {
        Api.post('/resetPassword', user)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getUser({ commit }) {
      return new Promise((resolve, reject) => {
        const token = localStorage.getItem('token')
        Api.defaults.headers.common['Authorization'] = `Bearer ${token}`
        Api.get('/me')
          .then((response) => {
            const user = response.data.user
            localStorage.setItem('user', JSON.stringify(user))
            commit('AUTH_USER', user)
            resolve(user)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    //action logout
    logout({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post('/logout', {
          ip_address: data.ip_address,
        })
          .then(() => {
            commit('AUTH_LOGOUT')
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            delete Api.defaults.headers.common['Authorization']
            resolve('')
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    //action login
    login({ commit }, user) {
      //define callback promise
      return new Promise((resolve, reject) => {
        Api.post('login', {
          //data yang dikirim ke server
          email: user.email,
          password: user.password,
          ip_address: user.ip_address,
        })

          .then((response) => {
            storeSession(commit, response.data)

            //resolve ke component dengan hasil response
            resolve(response)
          })
          .catch((error) => {
            localStorage.removeItem('token')
            //reject ke component dengan hasil response
            reject(error)
          })
      })
    },
    // Login by a 6-digit code mailed to the address (PMLI participants have no password).
    // The request always answers 200 whether or not the account exists.
    login_code_request(_ctx, email) {
      return Api.post('login/request-code', { email })
    },
    login_code_verify({ commit }, { email, code, ip_address }) {
      return new Promise((resolve, reject) => {
        Api.post('login/verify-code', { email, code, ip_address })
          .then((response) => {
            storeSession(commit, response.data)
            resolve(response)
          })
          .catch((error) => {
            localStorage.removeItem('token')
            reject(error)
          })
      })
    },
    login_google({ commit }, user) {
      //define callback promise
      return new Promise((resolve, reject) => {
        Api.post('login_by_google', {
          //data yang dikirim ke server; the backend trusts only the Google ID token (credential)
          credential: user.credential,
          email: user.email,
          fullname: user.fullname,
          ip_address: user.ip_address,
        })

          .then((response) => {
            //define variable dengan isi hasil response dari server
            const token = response.data.data.token
            const user = response.data.data.user

            //set localStorage untuk menyimpan token dan data user
            localStorage.setItem('token', token)
            localStorage.setItem('user', JSON.stringify(user))
            localStorage.setItem('with_google', 1)
            // A new account made with Google saw no marketing checkbox: MarketingPrompt asks once (UU PDP).
            if (response.data.data.is_new) localStorage.setItem('dl_ask_marketing', '1')

            //set default header axios dengan token
            Api.defaults.headers.common['Authorization'] = `Bearer ${token}`

            //commit auth success ke mutation
            commit('AUTH_SUCCESS', token, user)

            //resolve ke component dengan hasil response
            resolve(response)
          })
          .catch((error) => {
            localStorage.removeItem('token')
            //reject ke component dengan hasil response
            reject(error)
          })
      })
    },
  },

  //getters
  getters: {
    isLoggedIn(state) {
      return state.token
    },
    myProfile(state) {
      return state.user
    },
    getProfile(state) {
      return state.profile
    },
  },
}

export default auth
